import { Divider } from "primereact/divider";
import SignatureBox from "../../../../components/signature-box/SignatureBox";

/**
 * The three signatures of the audit: Dibuat (IT), Diketahui (Kabag Transport) and Diteliti (SD2).
 */
const EditorSignatureSection = ({
  headerData,
  verifSettingPengecekan,
  handleOnSignDibuat,
  handleOnSignDiketahui,
  handleOnSignDiteliti,
  handleValidateKeamanan,
}) => {
  return (
    <div className="col-start-start w-full gap-4">
      <div
        className={`elevated-card bottom-4 !px-5 !py-2 w-full row-around-start gap-0 `}
      >
        <SignatureBox
          disabled={!headerData.id}
          label="Dibuat"
          title="IT"
          fieldId="verif_dibuat_id"
          fieldData="data_verif_dibuat"
          fieldDatetime="verif_dibuat_datetime"
          verifField="audit_kendaraan:dibuat"
          jabatanId={verifSettingPengecekan.jabatan_id}
          jabatanIdRequirement={verifSettingPengecekan["it"]}
          field="verif_dibuat_id"
          data={headerData}
          onConfirm={handleOnSignDibuat}
        />
        <Divider className="h-[10rem] mx-3" layout="vertical" />
        <SignatureBox
          disabled={!headerData.id}
          label="Diketahui"
          title="Kabag Transport"
          fieldId="verif_diketahui_id"
          fieldData="data_verif_diketahui"
          fieldDatetime="verif_diketahui_datetime"
          verifField="audit_kendaraan:diketahui"
          jabatanId={verifSettingPengecekan.jabatan_id}
          jabatanIdRequirement={verifSettingPengecekan["kabag_transport"]}
          field="verif_diketahui_id"
          data={headerData}
          onConfirm={handleOnSignDiketahui}
          onValidate={handleValidateKeamanan}
        />
        <Divider className="h-[10rem] mx-3" layout="vertical" />
        <SignatureBox
          disabled={!headerData.id}
          label="Diteliti"
          title="SD2"
          fieldId="verif_diteliti_id"
          fieldData="data_verif_diteliti"
          fieldDatetime="verif_diteliti_datetime"
          verifField="audit_kendaraan:diteliti"
          jabatanId={verifSettingPengecekan.jabatan_id}
          jabatanIdRequirement={verifSettingPengecekan["sd2"]}
          field="verif_diteliti_id"
          data={headerData}
          onConfirm={handleOnSignDiteliti}
        />
      </div>
    </div>
  );
};

export default EditorSignatureSection;
